import { FIELD__list_image_asset } from '@shared/dto/generation/graph_invoke/_fields/_primitives/list/FIELD__list_image_asset';
import { FIELD__image_asset } from '@shared/dto/generation/graph_invoke/_fields/image/FIELD__image_asset';
import { G_GRAPH__BUTTON__list_images_clear } from '../../layouts/nodes/node/fields/image/list_image_asset/_buttons/G_GRAPH__BUTTON__list_images_clear';
import { G_GRAPH__BUTTON__list_images_download } from '../../layouts/nodes/node/fields/image/list_image_asset/_buttons/G_GRAPH__BUTTON__list_images_download';
import { G_GRAPH__BUTTON__list_images_upload } from '../../layouts/nodes/node/fields/image/list_image_asset/_buttons/G_GRAPH__BUTTON__list_images_upload';
import { G_GRAPH__BUTTON__list_images_view_in_fullscreen } from '../../layouts/nodes/node/fields/image/list_image_asset/_buttons/G_GRAPH__BUTTON__list_images_view_in_fullscreen';
import { G_HOOK__output__field_hovered_set } from '../_base/_hooks/G_HOOK__output__field_hovered_set';
import { G_UI_FIELD__header } from '../_base/G_UI_FIELD__header';
import { G_UI_FIELD__image_asset } from '../image_asset/G_UI_FIELD__image_asset';
import { G_UI_FIELD__image_asset_text } from '../image_asset/G_UI_FIELD__image_asset_text';
import { G_UI_FIELD__image_asset_list_empty_image } from './empty/G_UI_FIELD__image_asset_list_empty_image';
import { G_DROPDOWN__field_image_asset_list__transform } from './G_DROPDOWN__field_image_asset_list__transform';

interface PROPS {
  field: FIELD__list_image_asset;
}

export function G_UI_FIELD__image_asset_list({ field }: PROPS) {
  /*
   *
   */
  const { onMouseOver, onMouseLeave } = G_HOOK__output__field_hovered_set({ field });

  /*
   *
   */

  function render_content() {
    if (!field.meta.kind__is_input) return <></>; //not output
    if (field.meta.data__is_linked) return <G_UI_FIELD__image_asset_text text={'Field is linked'} {...{ field }} />;
    if (field.items.is_empty()) return <G_UI_FIELD__image_asset_list_empty_image {...{ field }} />;

    return field.items.map(render_image);
  }

  function render_image(field_image: FIELD__image_asset) {
    return <G_UI_FIELD__image_asset field={field_image} key={field_image.meta.field_id} />;
  }

  /*
   *
   */
  return (
    <div className="relative flex flex-col w-full" {...{ onMouseOver, onMouseLeave }}>
      <G_UI_FIELD__header {...{ field }} hide_buttons_grid2d_dimension>
        <>
          <G_GRAPH__BUTTON__list_images_upload {...{ field }} />
          <G_GRAPH__BUTTON__list_images_clear {...{ field }} />
          <G_GRAPH__BUTTON__list_images_download {...{ field }} />
          <G_GRAPH__BUTTON__list_images_view_in_fullscreen {...{ field }} />
          <G_DROPDOWN__field_image_asset_list__transform {...{ field }} />
        </>
      </G_UI_FIELD__header>
      <>{render_content()}</>
    </div>
  );
}
